import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _ from 'lodash';
import diacritics from 'remove-accents-diacritics';
var accentOnly = diacritics.remove;

var lowerOnly = function lowerOnly(t) {
  return t.toLowerCase();
};

var accentAndLower = _.flowRight(lowerOnly, accentOnly);

function normaliseText(text, ignoreAccents, ignoreCase) {
  var t = text || '';
  if (ignoreAccents && ignoreCase) t = accentAndLower(t);else if (ignoreAccents) t = accentOnly(t);else if (ignoreCase) t = lowerOnly(t);
  return t;
}
/**
 * Filters the options by their label.
 * eg. If a given option's label includes the given input term, it is added.
 * @param {Array} options
 * @param {{inputValue,pluckLabel,ignoreAccents,ignoreCase}} props
 */


function filterByLabel(options, props) {
  var inputValue = props.inputValue,
      pluckLabel = props.pluckLabel,
      ignoreAccents = props.ignoreAccents,
      ignoreCase = props.ignoreCase;
  return _reduceInstanceProperty(options).call(options, function (options, option) {
    var label = pluckLabel(option);
    var normalisedOptionLabel = normaliseText(label, ignoreAccents, ignoreCase);
    var normalisedTerm = normaliseText(inputValue, ignoreAccents, ignoreCase);

    if (_includesInstanceProperty(normalisedOptionLabel).call(normalisedOptionLabel, normalisedTerm)) {
      options.push(option);
    }

    return options;
  }, []);
}

export default filterByLabel;